/* global localStorage */

const KEY_PREFIX = "billiet-";

/** Persist a value to localStorage under a prefixed key. */
export function saveSettings<T>(key: string, value: T): void {
  try {
    localStorage.setItem(KEY_PREFIX + key, JSON.stringify(value));
  } catch {
    // Storage full or unavailable — silently ignore
  }
}

/** Load a previously persisted value. Returns null if missing or corrupt. */
export function loadSettings<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + key);
    if (raw === null) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
